<div #firstParent class="canvas h-100">
    <div class="canvas-container h-100" #canvasContainer>
        <canvas #canvas></canvas>
    </div>
</div>

<data-view-actions [mainComponent]="appComponent" [dataViewer]="this" [currentTabType]="TabType.VIEW"></data-view-actions>
<center-canvas [centerAction]="fitBoxesWithCamera"></center-canvas>
@if (isLoading) {
    <div class="h-100 d-flex justify-content-center align-items-center loading">
        <mat-progress-spinner mode="indeterminate"> </mat-progress-spinner>
    </div>
}